@if (count() > 1) {
  <div class="d-flex align-items-center gap-1 flex-shrink-0">
    <button matIconButton (click)="previous.emit()" [disabled]="index() === 0" aria-label="Anterior">
      <mat-icon>chevron_left</mat-icon>
    </button>
    <span class="mat-font-label-sm lh-1">{{ index() + 1 }} / {{ count() }}</span>
    <button matIconButton (click)="next.emit()" [disabled]="index() === count() - 1" aria-label="Siguiente">
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>
}
